<template>
  <a :class="['card', 'card-banner', colorClass, {'card-tile': tile, 'active': active}]" v-on:click="emitClick">
    <div class="card-body">
      <i :class="['icon', iconPrefix, iconClass]" v-if="!image"></i>
      <span class="icon" v-else>
        <img :src="image" style="max-width: 100%; max-height: 30vh" />
      </span>
      <div class="content">
        <div class="title" v-if="title">{{ title }}</div>
        <div class="value" v-if="value">{{ value }}</div>
        <slot></slot>
      </div>
    </div>
  </a>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: 'green-light' // green, blue, orange, yellow
    },
    icon: {
      type: String,
      default: 'thumbs-o-up'
    },
    title: {
      type: String
    },
    value: {
      type: String
    },
    tile: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    iconPrefix: {
      type: String,
      default: 'fa'
    },
    image: {
      type: String,
      default: null
    }
  },
  computed: {
    colorClass() {
      return 'card-' + this.color;
    },
    iconClass() {
      return 'fa-' + this.icon;
    }
  },
  methods: {
    emitClick() {
      this.$emit('click');
    }
  }
}
</script>
